<template>
  <v-app>
    <TopNav />
    <MobileNav />
    <v-content>
      <v-btn
        class="mobile-toggle"
        :color="isHome ? 'white' : 'black'"
        icon
        @click="$store.state.showMobileNav = true"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <router-view></router-view>
      <Footer />
    </v-content>
  </v-app>
</template>

<script>
import TopNav from "./components/TopNav.vue";
import MobileNav from "./components/MobileNav.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    TopNav,
    MobileNav,
    Footer,
  },
  computed: {
    isMobile() {
      return window.innerWidth < 1000;
    },
    isHome() {
      return this.$route.path === "/";
    },
  },
  head: {
    meta: [
      { name: 'fo-verify', content: '830c4d73-682c-4f16-92c8-b837a3fc20b2' },
    ]
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Noto+Sans+KR:400,500,700&display=swap");
@import url("https://fonts.googleapis.com/css?family=PT+Sans:400,700&display=swap");

* {
  scroll-behavior: smooth;
  font-family: "Noto Sans KR", sans-serif;
}

*::-webkit-scrollbar {
  display: none;
}

a {
  font-family: "PT Sans";
  text-decoration: none;
}

.kor {
  font-family: "Noto Sans KR", sans-serif !important;
}

.v-content {
  padding: 0 !important;
}

.flex-section {
  width: 100%;
  flex: 1;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  position: relative;
}

.flex-container {
  width: 100%;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  z-index: 1;
}

.flex-1 {
  -ms-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.flex-2 {
  -ms-flex: 2;
  -webkit-flex: 2;
  flex: 2;
}

.flex-3 {
  -ms-flex: 3;
  -webkit-flex: 3;
  flex: 3;
}

.v-label {
  font-size: 14px !important;
  line-height: 1.2 !important;
}

.view-port {
  width: 100vw;
  height: 100vh;
}

.wrap {
  flex-wrap: wrap;
}

.logo {
  width: 40px;
  height: 18px;
  object-fit: cover;
}

.center {
  justify-content: center;
  align-items: center;
}

.jc-center {
  justify-content: center;
}

.ai-center {
  align-items: center;
}

.ml-auto {
  margin-left: auto;
}

.color-black {
  color: black !important;
}

.color-white {
  color: white !important;
}

.color-grey {
  color: #898989;
}

.color-lightgrey {
  color: #eeeeee;
}

.color-blue {
  color: #2699fb;
}

.bg-dark {
  background-color: #1c1c1c;
}

.opaque {
  opacity: 0.7;
}

.space-15 {
  margin-bottom: 15px;
}

.space-25 {
  margin-bottom: 25px;
}

.padding-100 {
  padding: 0 100px;
}

.header-1 {
  font-size: 60px;
  letter-spacing: 0.5px;
  margin: 0 !important;
  font-family: "PT Sans";
  font-weight: bold;
}

.header-2 {
  font-size: 35px;
  letter-spacing: 0.5px;
  font-family: "PT Sans";
  font-weight: bold;
}

.header-3 {
  font-size: 24px;
  font-family: "PT Sans";
  font-weight: bold;
}

.header-4 {
  font-size: 16px;
  font-family: "PT Sans";
  font-weight: bold;
}

.text-1 {
  font-size: 15px;
  line-height: 1.5;
}

.text-2 {
  font-size: 14px;
  line-height: 1.5;
}

.text-3 {
  font-size: 12px;
  line-height: 1.5;
}

.lh-1 {
  line-height: 1;
}

.bold {
  font-weight: bold;
}

.medium {
  font-weight: 500 !important;
}

.normal {
  font-weight: normal;
}

.thin {
  font-weight: 300;
}

.section-wrapper {
  width: 1080px;
  height: 100%;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}

.relative {
  position: relative;
}
.clickable {
  cursor: pointer;
}

.shadowed {
  box-shadow: 6px 9px 18px 0px rgba(158, 158, 158, 0.5) !important;
  transition: 0.3s ease-in-out;
}

.btn-prev {
  width: 16px;
  height: 16px;
  transition: 0.3s ease-in-out;
  background: url("./assets/prevbtn_on.png");
  margin-left: 25px;
  cursor: pointer;
}

.disabled {
  cursor: default;
  opacity: 0.3;
  transition: 0.3s ease-in-out;
}

.btn-next {
  width: 16px;
  height: 16px;
  transition: 0.3s ease-in-out;
  background: url("./assets/nextbtn_on.png");
  margin-left: 25px;
  cursor: pointer;
}

.page-index {
  width: 16px;
  height: 16px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.mobile-toggle {
  display: none;
}

@media only screen and (max-width: 880px) {
  .header-1 {
    font-size: 23px;
  }

  .header-2 {
    font-size: 13px;
  }

  .text-1 {
    font-size: 12px;
  }

  .text-2 {
    font-size: 10px;
  }

  .text-3 {
    font-size: 8px;
  }

  .text-4 {
    font-size: 6px;
  }

  .section-wrapper {
    width: 300px;
    height: 100%;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    justify-content: center;
  }

  .btn-prev {
    margin-left: 10px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .btn-next {
    margin-left: 10px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .mobile-toggle {
    position: fixed;
    top: 10px;
    right: 10px;
    z-index: 3;
    display: block;
  }

  .mobile-top-nav {
    width: 100%;
    height: 55px;
    background: rgba(255, 255, 255, 0.9);
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
  }

  .mg-55 {
    margin-top: 55px;
  }
}
</style>
